import React from 'react';

import { ChevronRightIcon, ChevronDownIcon } from 'lucide-react';

import {
    Collapsible,
    CollapsibleContent,
    CollapsibleTrigger,
} from '../ui/collapsible';
import { cn } from '@/lib/utils';

interface PropertySectionProps {
    title: React.ReactNode;
    defaultOpen?: boolean;
    defaultBorder?: boolean;
    action?: React.ReactNode;
    children: React.ReactNode;
}

const PropertySection: React.FC<PropertySectionProps> = ({
    title,
    defaultOpen = false,
    defaultBorder = true,
    action,
    children,
}): React.ReactElement => {
    const [isOpen, setIsOpen] = React.useState(defaultOpen);

    return (
        <Collapsible
            defaultOpen={defaultOpen}
            onOpenChange={setIsOpen}
        >
            <div className={cn(defaultBorder && 'border-b border-border pb-1')}>
                <div className="flex items-center justify-between w-full pb-1">
                    <CollapsibleTrigger className="flex-1 flex items-center justify-between p-3 hover:bg-accent/50 rounded-lg transition-colors cursor-pointer">
                        <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
                            {title}
                        </span>
                        {isOpen ? (
                            <ChevronDownIcon className="h-3.5 w-3.5 text-muted-foreground transition-transform duration-200" />
                        ) : (
                            <ChevronRightIcon className="h-3.5 w-3.5 text-muted-foreground transition-transform duration-200" />
                        )}
                    </CollapsibleTrigger>
                    {action && (
                        <div className="pr-3" onClick={(e) => e.stopPropagation()}>
                            {action}
                        </div>
                    )}
                </div>
                <CollapsibleContent className="p-3 pt-0 space-y-3">
                    {children}
                </CollapsibleContent>
            </div>
        </Collapsible>
    );
};

export default PropertySection;
